let resolveStartup: any = null;

export const startupReady = new Promise((resolve) => {
  resolveStartup = resolve;
});

// 启动时机完成时调用
export const setStartupReady = () => {
  resolveStartup();
};